"use strict";

var _interopRequireDefault = require("/Users/mweeb/Desktop/codings/nq-component/node_modules/@babel/runtime/helpers/interopRequireDefault.js")["default"];
var _interopRequireWildcard = require("/Users/mweeb/Desktop/codings/nq-component/node_modules/@babel/runtime/helpers/interopRequireWildcard.js")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("/Users/mweeb/Desktop/codings/nq-component/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js"));
var _slicedToArray2 = _interopRequireDefault(require("/Users/mweeb/Desktop/codings/nq-component/node_modules/@babel/runtime/helpers/esm/slicedToArray.js"));
var _objectWithoutProperties2 = _interopRequireDefault(require("/Users/mweeb/Desktop/codings/nq-component/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js"));
var _react = _interopRequireWildcard(require("react"));
var _dialog = _interopRequireDefault(require("../Modal/dialog"));
var _SelectSearch = _interopRequireDefault(require("../SelectSearch"));
var _RelationDialog = _interopRequireDefault(require("../RelationDialog"));
var _GetOption = _interopRequireDefault(require("./GetOption"));
var _filterFields = _interopRequireDefault(require("../filterFields"));
var _objectToOption = _interopRequireDefault(require("./objectToOption"));
var _excluded = ["schema", "object", "pick", "target", "onChange", "isMulti", "where", "indexes", "field", "defaultValue", "findObject", "saveObject", "saveFile", "saveImage", "schemas", "keys", "dynamic", "sort", "includes"];
var _jsxFileName = "/Users/mweeb/Desktop/codings/nq-component/src/InputPointer/index.js";
var defaultProps = {
  includes: []
};
function InputPointer(_ref) {
  var schema = _ref.schema,
    object = _ref.object,
    pick = _ref.pick,
    target = _ref.target,
    onChange = _ref.onChange,
    isMulti = _ref.isMulti,
    where = _ref.where,
    indexes = _ref.indexes,
    field = _ref.field,
    defaultValue = _ref.defaultValue,
    findObject = _ref.findObject,
    saveObject = _ref.saveObject,
    saveFile = _ref.saveFile,
    saveImage = _ref.saveImage,
    schemas = _ref.schemas,
    keys = _ref.keys,
    dynamic = _ref.dynamic,
    sort = _ref.sort,
    includes = _ref.includes,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var _useState = (0, _react.useState)(isMulti ? [] : {
      label: '',
      value: ''
    }),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    value = _useState2[0],
    setValue = _useState2[1];
  var _useState3 = (0, _react.useState)([]),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    options = _useState4[0],
    setOptions = _useState4[1];
  var _useState5 = (0, _react.useState)(false),
    _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
    focus = _useState6[0],
    setFocus = _useState6[1];
  function onClickAdd() {
    var onClickItem = function onClickItem(object) {
      _onChange((0, _objectToOption["default"])(object, _indexes));
      _dialog["default"].close();
    };
    _dialog["default"].fire({
      html: /*#__PURE__*/_react["default"].createElement(_RelationDialog["default"], {
        onClickItem: onClickItem,
        schema: schema,
        objects: object,
        onCancel: function onCancel() {
          return _dialog["default"].close();
        },
        findObject: findObject,
        saveObject: saveObject,
        saveFile: saveFile,
        saveImage: saveImage,
        schemas: schemas,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 45,
          columnNumber: 20
        }
      }),
      footer: false
    });
  }

  // indexes use for display
  var _indexes = _react["default"].useMemo(function () {
    var items = indexes || (0, _filterFields["default"])(schema.fields, "_index");
    // if no index use name
    return items.length > 0 ? items : ['name'];
  }, [schema]);

  // keys use for selected keys for query
  var _keys = _react["default"].useMemo(function () {
    var items = keys || (0, _filterFields["default"])(schema.fields, "key");
    return items;
  }, [schema]);

  // set default value
  _react["default"].useEffect(function () {
    if (isMulti) {
      defaultValue && setValue(defaultValue.map(function (obj) {
        return (0, _objectToOption["default"])(obj, _indexes);
      }));
    } else {
      defaultValue && setValue((0, _objectToOption["default"])(defaultValue, _indexes));
    }
  }, [_indexes, defaultValue, isMulti]);
  function callback(options) {
    setOptions(options);
    // find default value
    if (defaultValue) {
      var option = options.find(function (o) {
        return o.value === defaultValue.id;
      });
      option && setValue(option);
    }
  }

  // load the initial select
  _react["default"].useEffect(function () {
    new _GetOption["default"](target, '', _indexes, findObject, where, callback, _keys, sort, includes);
  }, [target, _indexes]);
  function _onChange(option) {
    if (isMulti) {
      var newValue = [].concat((0, _toConsumableArray2["default"])(value), [option]);
      setValue(newValue);
      onChange(newValue.map(function (o) {
        return o.object;
      }));
    } else {
      setValue(option);
      onChange(option.object);
    }
  }
  function onClickClear() {
    setValue(isMulti ? [] : {
      label: "",
      value: ""
    });
    onChange(isMulti ? [] : {});
  }
  function onSearch(word) {
    new _GetOption["default"](target, word, _indexes, findObject, where, setOptions, _keys, sort, includes);
  }
  function getValue() {
    if (isMulti && !focus) {
      var values = value.map(function (v) {
        return v.label;
      }).reverse();
      return {
        label: values.join(', ')
      };
    }
    return value;
  }
  function getOptions() {
    // remove the selected from the option
    if (isMulti) {
      return options.filter(function (o) {
        return !value.includes(o);
      });
    }
    return options.filter(function (o) {
      return o !== value;
    });
  }
  return /*#__PURE__*/_react["default"].createElement(_SelectSearch["default"], Object.assign({
    label: "Select ".concat(target),
    value: getValue(),
    onChange: _onChange,
    onSearch: onSearch,
    options: getOptions(),
    onFocus: setFocus,
    onClickAdd: onClickAdd,
    onClickClear: onClickClear,
    dynamic: dynamic,
    focus: true
  }, props, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 131,
      columnNumber: 13
    }
  }));
}
InputPointer.defaultProps = defaultProps;
var _default = exports["default"] = InputPointer;